import { render } from "./OutOfOffice.vue?vue&type=template&id=9cb0a9a4"
import script from "./OutOfOffice.vue?vue&type=script&lang=js"
export * from "./OutOfOffice.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__